/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Exercise_Personal_Strength_Stronger_ThanInputs */

const en_us2_exercise_personal_strength_stronger_than = /** @type {(inputs: Exercise_Personal_Strength_Stronger_ThanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stronger than ${i?.pct}% of lifters your age and weight`)
};

const pt_br2_exercise_personal_strength_stronger_than = /** @type {(inputs: Exercise_Personal_Strength_Stronger_ThanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mais forte que ${i?.pct}% dos praticantes da sua idade e peso`)
};

const es_419_exercise_personal_strength_stronger_than = /** @type {(inputs: Exercise_Personal_Strength_Stronger_ThanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Más fuerte que el ${i?.pct}% de quienes entrenan con tu edad y peso`)
};

const pt_pt2_exercise_personal_strength_stronger_than = /** @type {(inputs: Exercise_Personal_Strength_Stronger_ThanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mais forte do que ${i?.pct}% dos praticantes da tua idade e peso`)
};

const fr_fr2_exercise_personal_strength_stronger_than = /** @type {(inputs: Exercise_Personal_Strength_Stronger_ThanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus fort que ${i?.pct} % des pratiquants de ton âge et de ton poids`)
};

const de_de2_exercise_personal_strength_stronger_than = /** @type {(inputs: Exercise_Personal_Strength_Stronger_ThanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stärker als ${i?.pct} % der Trainierenden in deinem Alter und mit deinem Gewicht`)
};

const it_it2_exercise_personal_strength_stronger_than = /** @type {(inputs: Exercise_Personal_Strength_Stronger_ThanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Più forte del ${i?.pct}% di chi si allena alla tua età e al tuo peso`)
};

/**
* | output |
* | --- |
* | "Stronger than {pct}% of lifters your age and weight" |
*
* @param {Exercise_Personal_Strength_Stronger_ThanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_stronger_than = /** @type {((inputs: Exercise_Personal_Strength_Stronger_ThanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_Stronger_ThanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_stronger_than(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_stronger_than(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_stronger_than(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_stronger_than(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_stronger_than(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_stronger_than(inputs)
	return en_us2_exercise_personal_strength_stronger_than(inputs)
});
export { exercise_personal_strength_stronger_than as "exercise-personal.strength_stronger_than" }